import React from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Input, Switch, Tooltip, Space } from "antd";

const MipresFields = ({
  form,
  handleChange,
  handleNoPbsChange,
  errors,
  isEditMode, // Nueva prop para identificar modo edición
  // Props para TAI
  handleTaiChange,
  hasPermissionTai = false,
}) => {
  const handleCodigoMipresChange = (e) => {
    const { value } = e.target;
    const regex = /^\d*$/;
    if (regex.test(value)) {
      handleChange(e);
    }
  };

  const isCodigoMipresInvalid =
    !form.no_pbs && form.codigo_mipres && form.codigo_mipres.length !== 20;

  const codigoMipresValidateStatus =
    isCodigoMipresInvalid || errors.codigo_mipres ? "error" : "";

  const codigoMipresHelp = isCodigoMipresInvalid
    ? "Debe ingresar exactamente 20 dígitos."
    : errors.codigo_mipres || "";

  // TAI solo se puede activar si es NO PBS
  const taiDisabled = isEditMode || !hasPermissionTai || !form.no_pbs;
  // NO PBS se deshabilita si TAI está activo (porque TAI siempre es NO PBS)
  const noPbsDisabled = isEditMode || form.es_tai;

  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Código MIPRES"
          required={!form.no_pbs}
          validateStatus={codigoMipresValidateStatus}
          help={codigoMipresHelp}
        >
          <Input
            name="codigo_mipres"
            value={form.codigo_mipres || ""}
            onChange={handleCodigoMipresChange}
            maxLength={20}
            disabled={form.no_pbs || isEditMode} // Se deshabilita si es no PBS o en modo edición
            placeholder="Ingrese 20 dígitos"
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label=" " colon={false}>
          <Space size="large">
            <Tooltip title={form.es_tai ? "TAI activo - NO PBS automático" : ""}>
              <Switch
                checked={form.no_pbs}
                onChange={handleNoPbsChange}
                checkedChildren="NO PBS"
                unCheckedChildren="PBS"
                name="no_pbs"
                disabled={noPbsDisabled}
                style={{ minWidth: 90 }}
              />
            </Tooltip>
            <Tooltip title={!form.no_pbs ? "Debe ser NO PBS para activar TAI" : ""}>
              <Switch
                checked={form.es_tai}
                onChange={handleTaiChange}
                checkedChildren="TAI"
                unCheckedChildren="Normal"
                disabled={taiDisabled}
                style={{
                  minWidth: 70,
                  backgroundColor: form.es_tai ? "#52c41a" : undefined,
                }}
              />
            </Tooltip>
          </Space>
        </Form.Item>
      </Col>
    </Row>
  );
};

MipresFields.propTypes = {
  form: PropTypes.shape({
    no_pbs: PropTypes.bool,
    codigo_mipres: PropTypes.string,
    es_tai: PropTypes.bool,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleNoPbsChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    codigo_mipres: PropTypes.string,
  }),
  isEditMode: PropTypes.bool.isRequired,
  handleTaiChange: PropTypes.func,
  hasPermissionTai: PropTypes.bool,
};

export default MipresFields;
